import type { ClientStorageItem } from './types';

import { BASE_URL } from '../constants';
import { del, get, put } from '../requestMethods';

const URL = `${BASE_URL}/api/clientStorage`;

export const CLIENT_STORAGE_API = {
  listItems: () => get<ClientStorageItem[]>(`${URL}/`),
  deleteItem: (key: string) => del(`${URL}/${key}`),
  getItem: (key: string) => get<ClientStorageItem>(`${URL}/${key}`),
  setItem: (key: string, value: string) => put<ClientStorageItem>(`${URL}/${key}`, { data: { value } }),
};

export type { ClientStorageItem, ClientStorageValue } from './types';
